module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "professional project-section container row"
  }, [_c('h2', [_vm._v("Professional")]), _vm._v(" "), _vm._l((_vm.projectsData.professional), function(project) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-4 project",
      on: {
        "click": function($event) {
          _vm.showDetails(project)
        }
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": project.images[0]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "row col-sm-11"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('li', [_c('em', [_vm._v(_vm._s(project.company))])])])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "side project-section container row"
  }, [_c('h2', [_vm._v("Others")]), _vm._v(" "), _vm._l((_vm.projectsData.others), function(project) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-4 project",
      on: {
        "click": function($event) {
          _vm.showDetails(project)
        }
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": project.images[0]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "row col-sm-11 project-details"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('li', [_c('em', [_vm._v(_vm._s(project.company))])])])])])])
  })], 2), _vm._v(" "), _c('bootstrap-modal', {
    ref: "projectDetails",
    attrs: {
      "size": "large"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.projectDetails.name))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-offset-1 col-sm-10"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.projectDetails.images[0]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.projectDetails.description), function(paragraph) {
    return _c('p', [_vm._v("\n            " + _vm._s(paragraph) + "\n          ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "details col-sm-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Company:")]), _vm._v(" "), (_vm.projectDetails.company) ? _c('td', [_vm._v(_vm._s(_vm.projectDetails.company))]) : _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Website:")]), _vm._v(" "), (_vm.projectDetails.website.url) ? _c('td', [_c('a', {
    attrs: {
      "href": _vm.projectDetails.website.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.projectDetails.website.name))])]) : _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Programming languages:")]), _vm._v(" "), (_vm.projectDetails.language) ? _c('td', [_vm._v(_vm._s(_vm.projectDetails.language))]) : _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Project Status:")]), _vm._v(" "), _c('td', [(_vm.projectDetails.finished) ? _c('span', [_vm._v("Finished")]) : _c('span', [_vm._v("In progress")])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Source Code:")]), _vm._v(" "), (_vm.projectDetails.sourceCode.url) ? _c('td', [_c('a', {
    attrs: {
      "href": _vm.projectDetails.sourceCode.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.projectDetails.sourceCode.name))])]) : _c('td', [_vm._v("-")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$refs.projectDetails.close()
      }
    }
  }, [_vm._v("Close")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Projects")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47859819","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects.vue
// module id = 388
// module chunks = 1